import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, Renderer2, ElementRef, ViewChild, HostListener } from '@angular/core';
import { CompanyService } from '../../services/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppDataService } from '../../services/app-data.service';

declare var Swiper: any;
declare var $:any;
@Component({
  selector: 'livetour',
  templateUrl: './livetour.html',
})
export class LivetourComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private _companyService: CompanyService,
    private _router: Router,
    public _appData: AppDataService,
    public _routeParams : ActivatedRoute
  ) {

  }
  ngOnDestroy(): void {
      
  }
  ngOnInit(): void {
      $('#main').css('overflow','auto')
  }
 }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/livetour/livetour.ts